<template>
  <div
    class="vm-feed"
    :class="{look1: is_open_comment_status,'footer-type': footer_type,'for-share': is_for_share, 'mobile-top-video': is_top_video}"
    @click.capture="capture">
    <template v-if="is_top_video">
      <video-player class="mb16 expand-margin" :class="{'no-radius': is_top_video}" v-if="post.video && !post.tcvideo" :post="post" :src="post.video" :pic="post.video_thumb" :duration="post.ext.video_duration || post.ext.rss_duration"></video-player>
      <!-- <tc-player class="mb16 expand-margin" :class="{'no-radius': is_top_video}" v-if="post.tcvideo" :tcvideo="post.tcvideo" :post="post"></tc-player> -->
    </template>
    <tag v-if="post && post.self_only == 1" class="circle gray mb16 pt4 pb4 pr8 pl8" :class="{pointer: is_verified == 0 && is_self}" @click.native="tap">
      {{post.status == 3 ? `${$t('c.Feed.text1')} - ` : ''}}{{$t('c.Feed.text2')}}
    </tag>
    <!-- <tag v-if="is_self && " class="circle gray mb16 pt4 pb4 pr8 pl8">草稿 - 仅自己可见</tag> -->
    <div v-if="post.warning" class="warning p8 lh1 fs12 flex-box flex-align-items-center mb16">
        <i class="afd afd-alert-circle mr8"></i>
        {{post.warning}}
    </div>
    <div
      v-if="album_id"
      class="flex-box flex-justify-content-space-between flex-align-items-center"
    >
      <div class="flex-box black-3 flex-align-items-center">
        <!-- <router-link class="black-3 fs12 gl-hover-text" :to="`/u/${user.user_id}`">{{ user.name }}</router-link> -->
        <span class="black-3 fs12 gl-hover-text" @click="$mixin_router_push($userlink(user).path)">{{ user.name }}</span>  
        <span class="ml10 mr10 black-3 fs12" v-if="post.can_edit">|</span>
        <span class="black-3 gl-hover-text fs12" v-if="post.can_edit" @click="edit_modal_feed">{{$t('c.Feed.text3')}}</span>
        <span class="ml10 mr10 black-3 fs12" v-if="post.can_delete">|</span>
        <span class="black-3 gl-hover-text fs12" v-if="post.can_delete" @click="del">{{$t('c.Feed.text4')}}</span>
      </div>
      <router-link
        v-if="post.status != 4"
        :target="is_href_blank ? '_blank' : false"
        :to="`/album/${album_id}/${post.post_id}`"
        class="fwn black-3 fsl12 gl-hover-text-purple">
        <span v-text="$time_show(post.publish_time)"></span>
      </router-link>
      <span v-if="post.status == 4" class="fwn flex-box flex-align-items-center fs12 red">
        <i class="afd afd-clock fs12 mr8"></i>
        <span>{{$t('c.Feed.text5')}} {{$time_show(post.timing * 1000, 'YYYY-MM-DD HH:mm')}} {{$t('c.Feed.text6')}}</span>
      </span>
    </div>
    <avatar v-else class="wh48" :user="user" :is_href_blank="is_href_blank">
      <div slot="doing" class="flex-box flex-align-items-center flex-justify-content-space-between">
        <div class="flex-box flex-align-items-center">
          <span class="black-3">{{$t('c.Feed.text7')}}</span>
          <template v-if="!is_for_share">
            <div class="line-vertical ml8" v-if="post.can_edit"></div>
            <span class="black-3 ml8 gl-hover-text" v-if="post.can_edit" @click="edit_modal_feed">{{$t('c.Feed.text8')}}</span>
            <span class="black-3 ml8 gl-hover-text" v-if="post.can_delete" @click="del">{{$t('c.Feed.text9')}}</span>
            <span class="black-3 ml8 gl-hover-text"
              v-if="group_id ? group.is_owner == 1 && post.user_group_top == 0 : is_self && post.user_top == 0"
              @click="top"
            >{{$t('c.Feed.text10')}}</span>
            <span class="black-3 ml8 gl-hover-text"
              v-if="group_id ? group.is_owner == 1 && post.user_group_top == 1 : is_self && post.user_top == 1"
              @click="untop"
            >{{$t('c.Feed.text11')}}</span>
          </template>
        </div>
        <div class="zhiding-tag flex-box flex-align-items-center"
          v-if="group_id ? post.user_group_top == 1 : post.user_top == 1">
          <i class="afd afd-zhiding"></i>{{$t('c.Feed.text12')}}
        </div>
      </div>
      <span slot="name-after" v-if="post.user_id == group.user_id" class="black-5 ml8 fwn fs12">{{$t('c.Feed.text13')}}</span>
      <span v-if="post.status == 4" slot="name-right" class="fwn flex-box flex-align-items-center fs12 red">
        <i class="afd afd-clock fs12 mr8"></i>
        <span>{{$t('c.Feed.text14')}} {{$time_show(post.timing * 1000, 'YYYY-MM-DD HH:mm')}} {{$t('c.Feed.text15')}}</span>
      </span>
      <router-link
        slot="name-right"
        v-else-if="!is_applying_apple && !is_applying_google && !is_for_share"
        :target="is_href_blank ? '_blank' : false"
        :to="to_detail_path"
        class="fwn black-3 fsl12 gl-hover-text-purple">
        <span v-text="$time_show(post.publish_time)"></span>
      </router-link>
      <span
        v-else-if="!is_for_share"
        slot="name-right"
        class="fwn black-3 fsl12 gl-hover-text-purple"
        v-text="$time_show(post.publish_time)"
      ></span>
    </avatar>
    <div
      class="feed-content mt16"
      :class="{article: post.has_right && post.type == feed_type.article && !is_show_content_all,'post-page': is_post_page,}">
      <template v-if="post.has_right">
        <template v-if="post.type == feed_type.normal">
          <div class="title-box fwb">
            <router-link
              :target="is_href_blank ? '_blank' : false"
              :to="to_detail_path"
            >{{ post.title }}</router-link>
          </div>
          <audio-player
            class="mt16"
            v-if="post.audio"
            :post="post"
            :src="post.audio"
            :pic="post.audio_thumb"
            :file_name="post.title || `${post.user.url_slug}-audio`"
            :is_download="allow_download_list.indexOf(post.user_id) != -1 || allow_download_album_list.indexOf(album_id) != -1"
          ></audio-player>
          <template v-if="!is_top_video">
            <tc-player class="mt16" v-if="post.tcvideo" :tcvideo="post.tcvideo" :post="post"></tc-player>
            <video-player class="mt16" v-if="post.video && !post.tcvideo" :post="post" :src="post.video" :pic="post.video_thumb" :duration="post.ext.video_duration || post.ext.rss_duration"></video-player>
          </template>
          <pre-box v-if="!post.rss_guid" v-no-copy="{on: can_copy_text}" :class="{nocopy: !can_copy_text}" class="mt16" :n="200" :text="post.content"></pre-box>
          <article-box
            v-if="post.rss_guid"
            v-no-copy="{on: can_copy_text}"
            class="mt16"
            :is_href_blank="is_href_blank"
            :url="to_detail_path"
            :text="post.content"
            :is_show_all="is_show_content_all"
          ></article-box>
          <div class="img-list flex-box flex-wrap mt16"
            v-if="post.pics.length > 0"
            :class="{'mobile-nocopy': mobile_nocopy, 'type-56789':[5, 6, 7, 8, 9].indexOf(Math.min(post.pics.length, 9)) != -1,'type-1': post.pics.length == 1,}">
            <template v-for="(pic, i) in post.pics">
              <div class="img-box" v-if="mobile_nocopy ? true : i < 9" :key="i">
                <div class="inner-img-box" @click="open_img(i)">
                  <pic
                    v-no-copy="{on: can_copy_pic}"
                    class="img-pre"
                    :src="mobile_nocopy ? $img_type(pic).src : post.pics.length == 1 ? ($img_type(pic).crop_src || $img_type(pic).src) : $img_type(pic).src"
                    :type="mobile_nocopy ? 2 : post.pics.length == 1 ? 3 : 1"
                    :width="mobile_nocopy ? ($img_type(pic).is_long * post.pics.length > 9 && GL.ENV.is_android ? 240 : 375) : post.pics.length == 1 ? 320 : 120"
                    :height="mobile_nocopy ? '' : post.pics.length == 1 ? 320 : 120"
                    :watermark="user.creator.watermark"
                    :watermark_text="user.name"
                  ></pic>
                  <img
                    v-if="$img_type(pic).is_gif"
                    class="gif-sign"
                    src="/static/img/asset/gif-sign.png"/>
                  <img
                    v-if="$img_type(pic).is_long && !mobile_nocopy"
                    class="long-sign"
                    src="/static/img/asset/longimage@2x.png"/>
                  <div
                    class="over-tip flex-box flex-center fs20 fwb"
                    v-if="post.pics.length > 9 && i == 8 && !mobile_nocopy"
                  >+{{ post.pics.length - 9 }}</div>
                </div>
              </div>
            </template>
          </div>
          <vote v-if="post.vote && post.vote.vote_id" class="mt10" :status="post.vote.finished == 1 ? 'finished' : post.vote.my_vote ? 'after' : 'before'" :vote="post.vote"/>
          <download-list class="mt16 p16" v-if="post.attachment.length > 0" :list="post.attachment"/>
        </template>
        <template v-if="post.type == feed_type.article">
          <!-- :style="{backgroundImage: is_post_page ? 'none' : `url(${deal_cover})`}" -->
          <router-link
            :target="is_href_blank ? '_blank' : false"
            :to="to_detail_path"
            class="article-cover-box block"
            v-if="post.cover">
            <pic v-if="is_post_page" v-no-copy="{on: can_copy_pic}" :afd-big-image="is_href_blank ? false : 1" :src="post.cover" :width="640" type="2"></pic>
            <pic v-else :src="deal_cover" v-no-copy="{on: can_copy_pic}"></pic>
          </router-link>
          <div v-if="post.title" class="title-box fwb gl-hover-text-purple mt16 mb16">
            <router-link
              :target="is_href_blank ? '_blank' : false"
              :to="to_detail_path"
            >{{ post.title }}</router-link>
          </div>
          <article-box
            v-no-copy="{on: can_copy_text && can_copy_pic, wrapper_text:can_copy_text, wrapper_pic: can_copy_pic, is_wrapper: 1}"
            :is_href_blank="is_href_blank"
            :url="to_detail_path"
            :text="post.content"
            :is_open_big_img="true"
            :is_show_all="is_show_content_all"
          ></article-box>
        </template>
      </template>
      <template v-else>
        <div v-if="post.title" @click="jump" class="title-box fwb gl-hover-text">{{ post.title }}</div>
        <div @click="jump" v-if="pre_type_name != 'pre_text' || post.has_video == 1 || post.has_audio == 1 || feed_type_name == 'article' || feed_type_name == 'vote'" class="lock-area mt16 relative" :class="[feed_type_name, pre_type_name]">
          <div class="flex-box flex-justify-content-space-between icon-area flex-align-items-center relative">
            <!-- <template v-if="!is_has_pre"> -->
              <pic
                v-if="post.content_length > 0 && feed_type_name =='normal' && post.cover == ''"
                width="70"
                height="70"
                :src="`${this.GL.PIC_HOST}/static/img/afd-lock-text@2x.png`"
                style="z-index:1"
              ></pic>
              <pic
                v-if="post.content_length > 0 && post.type == feed_type.article && post.cover == ''"
                width="70"
                height="70"
                class="icon-article"
                :src="`${this.GL.PIC_HOST}/static/img/afd-lock-article@2x.png`"
                style="z-index:1"
              ></pic>
              <i v-if="post.content_length > 0 && post.pics_count > 0 && post.cover == ''"
                class="afd afd-plus black-1 fs24 ml16 mr16"
              ></i>
              <pic
                v-if="post.pics_count > 0 && post.cover == ''"
                width="70"
                height="70"
                :src="`${this.GL.PIC_HOST}/static/img/afd-lock-images@2x.png`"
              ></pic>
            <!-- </template> -->
             <pic
                v-if="post.has_audio > 0"
                width="70"
                height="70"
                :src="post.has_audio && post.audio_thumb ? post.audio_thumb : `${this.GL.PIC_HOST}/static/img/afd-lock-audio@2x.png`"
              ></pic>
              <pic
                v-if="feed_type_name == 'vote'"
                class="icon-vote"
                width="70"
                height="70"
                style="z-index:1"
                :src="`${this.GL.PIC_HOST}/static/img/afd-lock-vote@2x.png`"
              ></pic>
              <pic
                v-if="post.has_video > 0 && post.cover || post.video_thumb"
                width="100%"
                class="cover"
                type="2"
                :height="browser_size == 'small' ? 96 : 168"
                :src="post.cover || post.video_thumb"
              ></pic>
            <pic
              v-if="post.cover && feed_type_name == 'article' || (feed_type_name == 'normal' && post.cover != '') || (feed_type_name == 'vote' && post.cover != '')"
              class="cover"
              type="2"
              width="100%"
              :height="300"
              :src="post.cover"
            ></pic>
            <div
              v-if="(feed_type_name == 'article' && post.cover != '') || feed_type_name == 'video' || (feed_type_name == 'normal' && post.cover != '') || (feed_type_name == 'vote' && post.cover != '')"
              class="article-cover-layer"
            ></div>
            <i v-if="post.has_video && post.video_thumb || post.has_video && is_has_pre" class="afd afd-video-sign"></i>
            <i v-if="post.has_audio && post.audio_thumb || post.has_audio && is_has_pre" class="afd afd-audio-sign"></i>
          </div>
          <template v-if="!hard_code_plan_redeem">
            <btn v-if="!is_applying_apple && !is_applying_google" class="size32">
              {{$t('c.Feed.text16')}}<template v-if="user.user_id == '51877d1637a511ec82bc52540025c377'">{{$t('c.Feed.text17')}}</template>
              <template v-if="post.min_price > 0">
                ￥{{ post.min_price }}
                <span v-if="!post.unlock_plan.permanent && !post.buyPlan">{{$t('c.Feed.text34')}}</span>
              </template>
            </btn>
            <div
              v-if="post.unlockCount > 0"
              class="unlock-count mq fs-14-12"
              :class="[post.cate == 'audio'&& post.cover ? 'black-3' : (post.cover || post.video_thumb) ? 'white' : 'black-3']"
            >{{$t('c.Feed.text18')}} {{post.unlockCount}} {{$t('c.Feed.text19')}}</div>
          </template>
          <template v-else>
            <btn>{{$t('c.Feed.text20')}}</btn>
          </template>
          <div class="duration-text fs12" v-if="post.ext && post.ext.video_duration > 0">{{$duration(post.ext.video_duration * 1000)}}</div>
        </div>
        <div v-if="pre_type_name == 'pre_text' || pre_type_name == 'pre_cover_text'" class="mt16 lock-area2" @click="jump">
          <pre-box class="pre-text-box black-8" :class="{over: pre_type_name == 'pre_text' && (feed_type_name == 'normal' || feed_type_name != 'article')}" :text="post.preview_text" :n="140"></pre-box>
          <div v-if="feed_type_name != 'vote' && pre_type_name == 'pre_text' && post.has_video == 0 && post.has_audio == 0 && feed_type_name != 'article'" class="mt16 flex-box flex-center flex-direction-column">
            <btn v-if="!is_applying_apple && !is_applying_google" class="size32">
              {{$t('c.Feed.text21')}}
              <template v-if="post.min_price > 0">
                ￥{{ post.min_price }}
                <span v-if="!post.unlock_plan.permanent && !post.buyPlan">{{$t('c.Feed.text22')}}</span>
              </template>
            </btn>
            <div
              v-if="post.unlockCount > 0 && feed_type_name != 'article'"
              class="unlock-count black-3 mt8 mq fs-14-12"
            >{{$t('c.Feed.text23')}} {{post.unlockCount}} {{$t('c.Feed.text24')}}</div>
          </div>
        </div>
        <div v-if="!is_for_share" class="flex-box flex-justify-content-space-between mt16">
          <p class="flex-box flex-align-items-center black-3 mq fs-14-12">
            <i
              class="afd afd-diandiandian fs14 hover-bg-purple black-3 gl-hover-text mr16"
              @click="more($event)"
            ></i>
            <template v-if="!is_applying_apple && !is_applying_google && (post.unlock_plan.permanent || (post.buyPlan && post.buyPlan.album_id) || is_sku_post)">
              <i class="afd afd-forever mr8 forever mq fs-14-12"></i>{{$t('c.Feed.text25')}}
            </template>
          </p>
          <div class="flex-box flex-align-items-center">
            <icon-collect class="mr16 fs20 hover-bg-purple" :data="post" @collect_success="collect_success" @uncollect_success="uncollect_success"/>
            <share :is_only_icon="true" :config="share_config"></share>
          </div>
        </div>
      </template>
    </div>
    <div class="footer-box" v-if="!is_for_share && post.has_right">
      <div class="flex-box flex-align-items-center footer-tip-box">
        <template v-if="post.has_right && !post.is_public && post.is_public != 1">
          <i class="afd afd-unlock mr8 cyan fs14"></i>
          <p class="black-5 fsl12 flex-box flex-align-items-center">
            {{$t('c.Feed.text26')}}
            <template v-if="post.min_price == 0">
              <router-link :to="`/a/${user.url_slug}/plan`" class="black-5 gl-hover-text-purple">{{$t('c.Feed.text27')}}</router-link>
            </template>
            <template v-else-if="post.buyPlan && post.buyPlan.album_id && post.buyPlan.plan">
              ￥{{ post.min_price }} {{$t('c.Feed.text28')}} - {{post.buyPlan.plan.name}} - {{post.buyPlan.name}}
            </template>
            <template v-else>
              <router-link
                :to="`/a/${user.url_slug}/plan`"
                class="black-5 gl-hover-text-purple plan-tip text-overflow-1"
              >
                <template v-if="post.unlock_plan && post.unlock_plan.independent == 1">
                  ￥{{ post.min_price }} {{$t('c.Feed.text29')}}
                  {{
                  post.unlock_plan.name
                  ? `- ${post.unlock_plan.name}`
                  : ""
                  }}
                </template>
                <template v-else>￥{{ post.min_price }}</template>
              </router-link>
            </template>{{$t('c.Feed.text30')}}
            <span v-if="post.unlock_plan.permanent || is_sku_post" class="forever ml8 fs12">{{$t('c.Feed.text31')}}</span>
          </p>
        </template>
      </div>
      <slot name="slot-1"></slot>
      <div class="flex-box flex-align-items-baseline footer-action-box flex-item-1">
        <div class="flex-box footer-btn-box flex-align-items-center flex-item-1">
          <div v-if="!footer_type" class="flex-item-1">
            <more-action v-if="is_applying_apple && !is_applying_google"></more-action>
            <i
              v-else
              class="afd afd-diandiandian fs14 hover-bg-purple black-3 gl-hover-text"
              @click="more($event)"
            ></i>
          </div>
          <like :data="post" @like_success="like_success" @unlike_success="unlike_success"></like>
          <template v-if="footer_type && !GL.ENV.is_wechat_mini">
            <div class="flex-item-1 flex-box flex-between flex-a-center collect-box">
                <div class="line-vertical"></div>
                <icon-collect class="fs20" style="padding: 20px 30px;flex: 1;text-align: center;" :data="post" @collect_success="collect_success" @uncollect_success="uncollect_success"/>
                <div class="line-vertical"></div>
            </div>
            <div class="flex-item-1">
                <share ref="footer_share" :config="share_config"></share>
            </div>
          </template>
          <template v-if="!footer_type">
            <div
              v-if="!is_hide_comment"
              class="hover-bg-purple flex-box flex-align-items-center fs14 gl-hover-text-purple relative comment-door ml18"
              :class="{purple: is_open_comment_status, 'black-3': !is_open_comment_status,}"
              @click="open_comment">
              <i class="afd mr4 afd-comment fs20"></i>
              <span>{{ post.comment_count }}</span>
              <div class="focus-line" v-if="is_open_comment_status"></div>
            </div>
            <icon-collect class="ml16 fs20 hover-bg-purple" :data="post" @collect_success="collect_success" @uncollect_success="uncollect_success"/>
            <share
              v-if="!GL.ENV.is_wechat_mini"
              class="ml18 hover-bg-purple"
              :is_only_icon="true"
              :config="share_config"
            ></share>
          </template>
        </div>
      </div>
    </div>
    <div class="flex-box mt16" v-if="old_new.old || old_new.new">
      <router-link
        v-if="old_new.old"
        replace
        :to="album_id ? `/album/${album_id}/${old_new.old.post_id}` : `/p/${old_new.old.post_id}`"
        class="tab-page-box flex-item-1"
      >
        <p class="tit">{{$t('c.Feed.text32')}}</p>
        <p>{{ old_new.old.title }}</p>
      </router-link>
      <router-link
        v-if="old_new.new"
        replace
        :to="album_id ? `/album/${album_id}/${old_new.new.post_id}` : `/p/${old_new.new.post_id}`"
        class="tab-page-box flex-item-1 ml16"
      >
        <p class="tit">{{$t('c.Feed.text33')}}</p>
        <p>{{ old_new.new.title }}</p>
      </router-link>
    </div>
    <comment
      v-if="!is_hide_comment"
      v-show="is_open_comment_status"
      ref="comment"
      class="mt-24-16 mq"
      :is_visit_post_page="is_visit_post_page"
      :is_need_toolbar="is_need_toolbar"
      :post="post"
      :group="group"
      :share_config="share_config"
      @publish_success="publish_success"
    ></comment>
  </div>
</template>

<script>
import {
  POST_POST_DELETE,
  POST_CREATOR_REM_ALBUM_POST,
  POST_TOP,
  POST_UNTOP,
  POST_POST_TOP_GROUP,
  POST_POST_UNTOP_GROUP,
} from '@/api/config';
import { mapState } from 'vuex';
const VideoPlayer = () => ({ component: import('@/components/VideoPlayer') });
const AudioPlayer = () => ({ component: import('@/components/AudioPlayer') });

export default {
  name: 'feed',
  props: {
    user: {
      type: Object,
      default() {
        return null;
      },
    },
    post: {
      type: Object,
      default() {
        return null;
      },
    },
    album_id: {
      type: String,
      default() {
        return '';
      },
    },
    group_id: {
      type: String,
      default() {
        return '';
      },
    },
    is_init_load_comment: {
      type: Boolean,
      default() {
        return false;
      },
    },
    is_visit_post_page: {
      type: Boolean,
      default() {
        return false;
      },
    },
    is_need_toolbar: {
      type: Boolean,
      default() {
        return false;
      },
    },
    is_show_content_all: {
      type: Boolean,
      default() {
        return false;
      },
    },
    is_post_page: {
      type: Boolean,
      default() {
        return false;
      },
    },
    is_href_blank: {
      type: Boolean,
      default() {
        return false;
      },
    },
    footer_type: {
      type: Boolean,
      default() {
        return false;
      },
    },
    old_new: {
      type: Object,
      default() {
        return {};
      },
    },
    group: {
      type: Object,
      default() {
        return {};
      },
    },
    is_for_share: {
      type: Boolean,
      default() {
        return false;
      },
    }
  },
  data() {
    return {
      allow_download_list: [
        '84a28926554c11ea820052540025c377',
        '179f19102e7111e8bf4d52540025c377',
        '9e0d33fa340311e8ba9f52540025c377',
        '21aab3685ad211e992e752540025c377',
      ],
      allow_download_album_list: [
        'c990c4c88d1c11ea81cd52540025c377',
        '42929fcc8d1d11ea8e6752540025c377',
      ],
      type: 'old',
      has_load_comment: false,
      is_click_open: false,
    };
  },
  inject:['app_action_sheet'],
  components: {
    VideoPlayer,
    AudioPlayer,
    // 'tc-player':TCPlayer,
  },
  computed: {
    ...mapState('app', [
      'session_user',
      'browser_size',
      'feed_type',
      'is_applying_apple',
      'is_applying_google',
      'white_list',
      'black_list'
    ]),
    to_detail_path(){
      let path =  this.album_id ? `/album/${this.album_id}/${this.post.post_id}` : `/p/${this.post.post_id}`;
      if(this.is_href_blank && !this.GL.ENV.is_afd_client && this.GL.ENV.is_mobile){
          path += '?new_page_tab=1'
      }
      return path
    },
    hard_code_plan_redeem(){
      let plans = this.white_list.PLANS_LINGQU.map(v => v.plan_id);
      let paths = this.white_list.PLANS_LINGQU.map(v => v.path); 
      if(this.post.plan_ids){
        let index = -1;
        this.post.plan_ids.forEach((v, k)=> {
          let i = plans.indexOf(v) 
          if(i != -1){
            index = i
          }
        })
        if(index != -1){
          return paths[index]
        }
      }
      return ''
    },
    mobile_nocopy(){
      return !this.can_copy_pic && this.browser_size == 'small' && ['pPostId','albumAlbumIdPostId'].indexOf(this.$route.name) != -1
    },
    is_top_video(){
      return this.browser_size == 'small' && this.$route.name == 'pPostId' && (this.post.video || this.post.tcvideo)
    },
    is_has_pre(){
      return ['pre_text','pre_cover','pre_cover_text'].indexOf(this.pre_type_name) != -1
    },
    is_hide_comment(){
      return this.user && this.black_list.HIDE_COMMENT_USERS.indexOf(this.user.user_id) != -1
    },
    pre_type_name(){
        let re = 'pre_no';
        if(this.post.is_public == 0){
            if(this.post.preview_text){
                re = `pre_text`;
            }
            if(this.post.cover){
                re = 'pre_cover';
            }
            if(this.post.cover && this.post.preview_text){
                re = 'pre_cover_text';
            }
        }
      return re;
    },
    feed_type_name() {
      let re = 'normal';
      if (this.post.type == this.feed_type.article) {
        re = 'article';
      } else if (this.post.has_video) {
        re = 'video';
      } else if (this.post.has_audio) {
        re = 'audio';
      }else if (this.post.cate == 'vote') {
        re = 'vote';
      }
      return re;
    },
    is_verified(){
      if (
        this.user &&
        this.user.is_verified
      ) {
        return 1;
      }
      return 0;
    },
    is_self() {
      return (
        this.session_user && this.user.user_id == this.session_user.user_id
      );
    },
    is_open_comment_status() {
      return (
        this.is_init_load_comment ||
        (this.is_click_open && this.has_load_comment)
      );
    },
    is_sku_post(){
      return !!(this.post.ext && this.post.ext.sku_id)
    },
    can_copy_text(){
      if(this.post.group_id == '7cb723b0058c11ec9fc652540025c377'){
        return true;
      }
      if (
        this.post &&
        this.post.user &&
        this.post.user.creator &&
        this.post.user.creator.can_copy_text
      ) {
        return true;
      }
      return false;
    },
    can_copy_pic(){
      if(this.post.group_id == '7cb723b0058c11ec9fc652540025c377' || this.is_for_share){
        return true;
      }
      if (
        this.post &&
        this.post.user &&
        this.post.user.creator &&
        this.post.user.creator.can_copy_pic
      ) {
        return true;
      }
      return false;
    },
    share_config() {
      let username = this.user && this.user.name;
      // let share_text =
      //   this.post.type == this.feed_type.article
      //     ? this.post.title
      //     : this.$remove_html_tag(this.post.content);
      // console.log(this.post.content)
      let share_text = this.$unescape_html(this.$remove_html_tag(this.post.content))

      share_text = share_text.replace(/\n|\r|\s/g, '').substring(0, 32)
      let url = `${location.origin}/p/${this.post && this.post.post_id}`
      if(this.$route.name == 'albumAlbumIdPostId'){
        url = location.href
      }
      return {
        url,
        source: `${location.origin}`,
        title:
          this.post && this.post.title
            ? `${this.post.title} | 爱发电`
            : `${username}发布的内容 | 爱发电`,
        description:
          this.post && this.post.is_public
            ? `${this.GL.ENV.is_wechat ? '' : '#为爱发电#  '}${username}在爱发电发布了动态：${share_text}（分享自 @爱发电）`
            : `${this.GL.ENV.is_wechat ? '' : '#为爱发电#  '}${username}在爱发电发布了动态：本条动态内容仅赞助者可见，快来成为${username}的赞助者吧~（分享自 @爱发电）`,
        pic:
          this.post && this.post.pics.length > 0
            ? this.post.pics[0]
            : this.user && this.user.avatar,
        wx_description: this.post && this.post.is_public ? share_text : `本条动态内容仅赞助者可见，快来成为${username}的赞助者吧~`,
        post_id: this.post && this.post.post_id,
        this_user: this.user,
        extra_btns: [
          {
            func_name: 'share_post',
            param: {
              val: `https://afdian.net/p/${this.post && this.post.post_id}`,
              user: this.user,
              post_id: this.post && this.post.post_id,
            },
            icon: `${this.GL.PIC_HOST}/static/img/icon-saveimage.png`,
            title: '保存图片并分享',
          },
        ],
      };
    },
    deal_cover() {
      return this.$img_src({
        src: this.post.cover,
        width: this.browser_size == 'small' ? 343 : 590,
        height: this.browser_size == 'small' ? 193 : 332,
      });
    },
  },
  beforeRouteLeave(to, from, next) {
    next(this.$mixin_client_router(to));
  },
  mounted() {
    if (this.is_init_load_comment) {
      this.load_comment();
    }
    this.$emit('mounted')
  },
  methods: {
    jump_download() {
      if (!this.session_user) {
        this.$store.commit('app/set:redirect_url', this.$route.fullPath);
        this.$mixin_router_push('/login');
        return false;
      }
      return false;
      if (!this.GL.ENV.is_android && this.browser_size == 'small') {
        this.$notify({
          title: '请用电脑访问爱发电下载',
          group: 'error',
        });
      }
    },
    more(e) {
      this.app_action_sheet('open', {
            component:'action-feed-setting',
            target:e.target,
            location_type:['left','bottom'],
            params:{
                post_id:this.post.post_id,
                user_id: this.user.user_id
            }
      })
    },
    open_img(index) {
      if (this.is_for_share) {
        return false;
      }
      if(!this.can_copy_pic && this.browser_size == 'small' && ['albumAlbumIdPostId','slug','feed','groupGroupId','albumAlbumId','pPostId'].indexOf(this.$route.name) != -1){
        this.$router.push(this.to_detail_path)
        return false;
      }
      this.$mixin_show_modal_img(index, this.post.pics,'','',true, this.can_copy_pic,this.user.creator.watermark,this.user.name);
    },
    async edit_modal_feed() {
      let p = JSON.parse(JSON.stringify(this.post));
      if (p.type == this.feed_type.article) {
        let album_ids = p.album_ids && p.album_ids.length > 0 ? p.album_ids.join(',') : ''
        // console.log(p)
        this.$mixin_router_push(`/edit/article?post_id=${p.post_id}&album_ids=${album_ids}&group_id=${p.group_id}`,'','','1');
        return false;
      }
      if(this.GL.ENV.is_afd_client){
          this.$mixin_router_push(`/compose?post_id=${p.post_id}`,'','','1')
          return false;
      }
      this.$modal.show(
        () => import('@/components/ModalFeed'),
        {
          sku_post: this.is_sku_post ? 1 : 0,
          title: p.title,
          post_id: p.post_id,
          pics: p.pics.map((v) => {
            return { online: v };
          }),
          tit: this.is_sku_post ? '编辑关联动态' : p.group_id ? '编辑帖子' : '编辑动态',
          content: p.content,
          permission_value:
            p.is_public == 1 ? 'public' : p.min_price,
          plan_id: p.plan_ids.length > 0 ? p.plan_ids[0] : '',
          video_thumb: p.video_thumb,
          video: p.video,
          audio_thumb: p.audio_thumb,
          album_ids:p.album_ids,
          audio: p.audio,
          buyPlan: p.buyPlan,
          attachment: p.attachment.map((v) => {
            return Object.assign(v, { success: true }); //为了组件内样式
          }),
          timing:p.timing * 1000,  //服务的存的是秒
          status:p.status,
          preview_text:p.preview_text,
          cover:p.cover,
          albums:p.albums,
          vote:p.vote,
        },
        {
          pivotY: this.browser_size == 'small' ? 0.5 : 0.15,
          clickToClose: false,
          classes: 'v--modal-feed v--modal',
          height: this.browser_size == 'small' ? '100%' : 'auto',
          width: this.browser_size == 'small' ? '100%' : 1000,
          adaptive: this.browser_size == 'small' ? true : false,
        }
      );
    },
    like_success() {
      this.post.like_count++;
      this.post.has_like = !this.post.has_like;
    },
    unlike_success() {
      this.post.like_count--;
      this.post.has_like = !this.post.has_like;
    },
    collect_success() {
      this.post.has_mark = 1;
    },
    uncollect_success() {
      this.post.has_mark = 0;
    },
    publish_success() {
      this.post.comment_count++;
    },
    async top() {
      let re = await this.$mixin_confirm({title:`确认置顶？`});
      if(re == false){
        return false
      }
      let API = this.group_id ? POST_POST_TOP_GROUP : POST_TOP;
      if (this.$http.is_run(API)) {
        return false;
      }
      let data = await this.$http.$axios(API, {
        post_id: this.post.post_id,
      });

      if (data.ec != 200) {
        this.$notify({
          title: data.em,
          group: 'error',
        });
        return false;
      }

      this.$notify({
        title: data.em,
        group: 'success',
      });
      this.$emit('refresh');
      return true;
    },
    async untop() {
      let re = await this.$mixin_confirm({title:`取消置顶？`});
      if(re == false){
        return false
      }
      let API = this.group_id ? POST_POST_UNTOP_GROUP : POST_UNTOP;

      if (this.$http.is_run(API)) {
        return false;
      }
      let data = await this.$http.$axios(API, {
        post_id: this.post.post_id,
      });

      if (data.ec != 200) {
        this.$notify({
          title: data.em,
          group: 'error',
        });
        return false;
      }

      this.$notify({
        title: data.em,
        group: 'success',
      });
      this.$emit('refresh');
      return true;
    },
    del() {
      this.$modal.show('dialog', {
        title: this.$t('c.dialog.text3'),
        buttons: [
          {
            title: this.$t('c.dialog.text1'),
            handler: () => {
              this.$modal.hide('dialog');
            },
          },
          {
            title: this.$t('c.dialog.text2'),
            handler: async () => {
              if (await this.del_feed()) {
                this.$modal.hide('dialog');
                this.$bus.$emit('FEED_REMOVE_SUCCESS', {
                  post_id: this.post.post_id,
                });
              }
            },
          },
        ],
      });
    },
    async del_feed() {
      let API = this.album_id ? POST_CREATOR_REM_ALBUM_POST : POST_POST_DELETE;
      let post_data = this.album_id
        ? { post_id: this.post.post_id, album_id: this.album_id }
        : { post_id: this.post.post_id };
      if (this.$http.is_run(API)) {
        return false;
      }
      let data = await this.$http.$axios(API, post_data);

      if (data.ec != 200) {
        this.$notify({
          title: data.em,
          group: 'error',
        });
        return false;
      }

      this.$notify({
        title: data.em,
        group: 'success',
      });
      return true;
    },
    open_comment() {
      if (this.is_init_load_comment) {
        return false;
      }
      if (!this.has_load_comment) {
        this.load_comment();
        this.has_load_comment = true;
      }
      this.is_click_open = !this.is_click_open;
    },
    load_comment() {
      if(this.is_hide_comment){
        return false;
      }
      this.$refs.comment.get_comment({
        post_id: this.post.post_id,
        hot: 1,
      });
    },
    capture(e) {
      if (this.is_for_share) {
        if (e.preventDefault) {
          e.preventDefault();
        }
        return false;
      }
    },
    jump(){
      let path = '';
      let query = {};
      if(this.hard_code_plan_redeem){
        this.$mixin_router_push(this.hard_code_plan_redeem)
        return false;
      }
      if(this.is_applying_apple){
        return false;
      }
      if(this.is_applying_google){
        return false;
      }
      else if((this.post.buyPlan && this.post.buyPlan.album_id) || (this.post.ext && this.post.ext.buy_sku)){
        path = "/order/create";
        query = {
          product_type: 1,
          plan_id: this.post.buyPlan.plan_id,
          sku: JSON.stringify([{ sku_id: this.post.buyPlan.sku_id, count: 1}]),
        }
      }
      else if(this.post.unlock_plan_id){
        path = '/order/create';
        query = {
          plan_id: this.post.unlock_plan_id
        }
      }
      else {
        path = `/a/${this.user.url_slug}/plan`;
        if(this.post.unlock_plan_ids && this.post.unlock_plan_ids.length > 0){
            query = {
                unlock_plan_ids: this.post.unlock_plan_ids.join(',')
            }
        }
      }
      this.$router.push({
        path,
        query,
      });
    },
    tap(){
      // let text = `你好，我已阅读上述认证流程，特来申请创作者认证，这是我在其他平台的主页网址：`;
      if(this.is_verified == 0 && this.is_self){
        this.$router.push(`/apply/certify`);
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.vm-feed {
  // padding: px2rem(24);
  padding: px2rem(24);
  background: $white;
  border-radius: 4px;
  border: 1px solid $black-1;

  .expand-margin{
    margin-left:-16px;
    margin-right:-16px;
  }
  &.mobile-top-video{
    padding-top:0;
  }
  &.look1 {
    padding-bottom: px2rem(16);
  }
  .player-wrapper{

  }

  &.for-share {
    .img-pre {
      cursor: default;
    }
    .lock-area {
        &.video, &.article {
            height:176px;
        }
    }
  }

  &.footer-type {
    .footer-action-box {
      width: 100%;
      flex-shrink: 0;
      order: 2;

      .footer-btn-box {
        display: flex;
        width: 100%;
        align-items: center;

        .vm-like, .vm-share, .collect-box {
          flex: 1;
          margin: 0;
          padding: px2rem(24) 0;
          justify-content: center;

          &:hover {
            background: $black-03;
          }
        }
        .collect-box{
          padding: 0;
          justify-content: space-between;
        }

        .vm-share /deep/ {
          .share-door {
            justify-content: center;
          }

          .afd-share {
            color: $purple;
          }
        }
      }
    }

    .footer-tip-box {
      margin-bottom: px2rem(8);
      order: 1;
    }
  }

  .vm-avatar /deep/ {
    .user-name {
      font-size: fs2rem(16);
    }
  }

  .hide-text {
    background: $black-05;
    border-radius: px2rem(4);
    height: px2rem(16);
  }

  .footer-box {
    // display: flex;
    justify-content: space-between;
    margin-top: px2rem(16);
    flex-wrap: wrap;
  }

  .vm-share {
    color: $black-3;
  }

  .lock-area {
    // height px2rem(184)
    padding: px2rem(24);
    background: $black-03;
    border-radius: 4px;
    flex-direction: column;
    display: flex;
    align-items: center;
    justify-content: center;

    // &.vote,
    &.video{
      height: 300px;
      padding: 0;
      overflow: hidden;
    }
    // &.pre_cover,
    // &.pre_cover_text


    &.audio,
    &.article.pre_no,
    &.article.pre_text,
    &.vote.pre_no,
    &.vote.pre_text,
    &.normal.pre_no {
      .vm-btn {
        margin-top: 10px;
      }

      .unlock-count {
        position: static;
        transform: none;
        // color: #000;
        margin-top: 10px;
      }
      .icon-article,
      .icon-vote{
        position: relative;
        left:auto;
        top:auto;
        transform: translate(0,0)
      }
    }
    &.article{
        // &.pre_no{
        //     .vm-btn {
        //         margin-top: 10px;
        //     }
        //     .unlock-count {
        //         position: static;
        //         transform: none;
        //         margin-top: 10px;
        //         // color: $black-3;
        //     }
        // }
        &.pre_cover,
        &.pre_cover_text{
            padding-bottom:50%;
            overflow: hidden;
            .vm-btn {
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
            }

            .icon-area {
                width: 100%;
                height: 100%;
                // align-items: flex-start;
                justify-content: center;
                top:0;
                left:0;
                position: absolute;
            }
        }
    }
    &.video,
    &.vote.pre_cover_text,
    &.vote.pre_cover,
    &.normal.pre_cover_text,
    &.normal.pre_cover{
      height: 300px;
      padding: 0;
      overflow: hidden;

      .vm-btn {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }

      .icon-area {
        width: 100%;
        height: 100%;
        // align-items: flex-start;
        justify-content: center;
      }
    }
    &.video {
      height: 336px;
    }


    .icon-area {
      .afd-article-sign, .afd-audio-sign {
        position: absolute;
        bottom: px2rem(8);
        right: px2rem(8);
        font-size: 24px;
        color: $white;
        text-shadow: 0 1px 2px $black-2;
      }

      .afd-video-sign {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50px);
        color: #fff;
        font-size: 20px;
      }
      .icon-article,
      .icon-vote{
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -115px);
      }

      .vm-pic {
        height: 70px;
        width: 70px;
      }

      .vm-pic.cover {
        object-fit: cover;
        // height: auto;
        // width: 130%;
        // max-width: 130%;
        width: 100%;
        height: 100%;
      }

      .article-cover-layer {
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        right: 0;
        background: rgba(0, 0, 0, 0.1);
      }
    }

    .unlock-count {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, 33px);
    }

    .vm-btn {
      padding: 13px 50px;
    }
  }
  .lock-area2{
    .vm-btn {
      padding: 13px 50px;
    }
  }
  .pre-text-box{
    position:relative;
    &.over{
        &::after{
            content:'';
            position:absolute;
            left:0;
            top:0;
            bottom:0;
            right:0;
            background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%);
        }
    }
  }
  .vm-vote /deep/{
      background:$white-bg;
  }

  .img-list {
    &.type-56789 { // 在图片个数为5、6、9时候为三栏布局
      width: px2rem(384);
    }

    &.type-1 { // 在图片个数为1 时候
      .img-box {
        width: auto;
        height: auto;
        max-width: px2rem(320);
        margin-right: px2rem(0);
        margin-bottom: px2rem(0);
        max-height: 50vh;

        .img-pre {
          width: auto;
          position: relative;
          display: block;
        }

        .inner-img-box {
          max-width: 100%;
          position: relative;
          padding: 0;
          height: 100%;
        }
      }
    }
    &.mobile-nocopy{
      .img-box{
        width:100%;
        border:0;
        margin-right:0;
        max-height: initial;
        max-width:100%;
        .img-pre{
          width:100%;
          position:relative;
        }
        .inner-img-box{
          padding-bottom:0;
        }
      }
    }
  }

  .feed-content {
    &.article {
      box-shadow: $layer-shadow;

      .title-box {
        margin: 0 !important;
        padding: px2rem(16) px2rem(24);
        padding-bottom: px2rem(8);
      }

      .vm-article-box {
        padding: px2rem(24);
        padding-top: 0;
      }
      .article-cover-box {
        img.vm-pic {
            position: absolute;
            -o-object-fit: cover;
            object-fit: cover;
            height: 100%;
        }
    }
    }

    &.post-page {
      .article-cover-box {
        height: auto;
        padding-bottom: 0;
      }
    }
  }

  .img-box {
    width: px2rem(120);
    height: px2rem(120);
    box-sizing: border-box;
    background: $black-05;
    margin-right: px2rem(8);
    margin-bottom: px2rem(8);
    border-radius: px2rem(4);
    overflow: hidden;
    border: 1px solid $black-05;
  }

  .inner-img-box {
    position: relative;
    height: 100%;
  }

  .over-tip {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: $black-5;
    color: $white;
    cursor: zoom-in;
    z-index:1;
  }

  .img-pre {
    cursor: zoom-in;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    border-radius: px2rem(4);
    width: px2rem(320);
    max-width: 100%;
  }

  .gif-sign {
    width: px2rem(32);
    height: px2rem(20);
    right: px2rem(10);
    top: px2rem(10);
    position: absolute;
    cursor: zoom-in;
    z-index:1;
  }

  .long-sign {
    width: px2rem(32);
    height: px2rem(20);
    right: px2rem(10);
    bottom: px2rem(10);
    position: absolute;
    cursor: zoom-in;
    z-index:1;
  }

  .focus-line {
    width: 100%;
    height: px2rem(2);
    background: $purple;
    bottom: _px2rem(21);
    position: absolute;
    left: 0;
  }

  .title-box {
    font-size: fs2rem(24);
  }

  .article-cover {
    // height px2rem(416)
  }

  .content-box {
    // padding px2rem(16)
    // background $black-03
  }

  .article-cover-box {
    // height px2rem(416)
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    height: 0;
    padding-bottom: 50%;
    position: relative;
    overflow: hidden;

    .vm-pic {
      max-width: 100%;
      /* max-height 100% */
    }
  }

  .tab-page-box {
    color: rgba(0, 0, 0, 0.3);
    padding: 24px 32px;
    border-radius: 4px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    max-width: 50%;
    box-sizing: border-box;

    .tit {
      color: #FCB23A;
      font-size: 24px;
      font-weight: bold;
    }

    &:hover {
      cursor: pointer;
      background: #f7f7f7;
    }
  }

  .plan-tip {
    max-width: 170px;
  }
  .warning{
    background:$orange-1;
    color:$orange;
    border-radius: 2px;
  }
  .vm-download-list{
    background: #FAFAFA;
    border-radius: 2px;
  }
  .footer-tip-box{
        margin-bottom:8px;
    }
  .duration-text{
        position: absolute;
        right: 8px;
        bottom: 8px;
        color: $white;
  }

  @media (max-width: $width-mobile) {
    padding-left: 16px;
    padding-right: 16px;

    .article-cover-box {
      // height auto
    }
    .footer-tip-box{
        margin-bottom:0px;
    }


    .tab-page-box {
      padding: 16px;

      .tit {
        font-size: 16px;
      }
    }

    .feed-content {
      &.article {
        .title-box {
          padding: px2rem(16);
          padding-bottom: px2rem(8);
        }

        .vm-article-box {
          padding: px2rem(16);
          padding-top: 0;
        }
      }

      .vm-btn {
        padding: 10px 16px;
      }
    }

    .footer-box {
      display: block;
      margin-top: px2rem(0);
    }

    .footer-action-box, .footer-tip-box {
      margin-top: 16px;
    }

    .img-list {
      &.type-56789 {
        width: 100%;
      }
    }

    .img-box {
      width: 31.5%;
      flex-shrink: 0;
      height: auto;

      .inner-img-box {
        padding-bottom: 100%;
        height: auto;
      }

      &:nth-child(3n) {
        margin-right: 0;
      }
    }

    .focus-line {
      bottom: _px2rem(15);
    }

    .lock-area {
      &.vote.pre_cover_text,
      &.vote.pre_cover,
      &.normal.pre_cover_text,
      &.normal.pre_cover{
        height: 172px;
        // background:transparent;
        .icon-article,
        .icon-vote{
            transform: translate(-50%, -85px);
        }
      }

      &.video {
        height: 192px;
        background:transparent;
      }
    }
  }

  .zhiding-tag {
    background-color: #1147E4;
    border-radius: 2px;
    color: $white;
    padding: 3px 5px;
    line-height: 1;

    .afd {
      transform: scale(0.8);
      font-size: 12px;
      margin-right: 2px;
    }
  }
}
</style>
